const intersection = <T>(a: T[], b: T[]): T[] => a.filter((valueA) => !!b.find((valueB) => valueB === valueA));

export default intersection;
